import { getAxiosInstance } from './api'

const api = getAxiosInstance()

export const addWhitelist = async (wallet: string, type: string) => {
  const params = {
    wallet: wallet.toLowerCase(),
    type,
  }

  const response = await api.post('/whitelist', params)
  return response.data
}

export const createOrder = async (params: {
  token_amount: string
  wallet?: string
  item_amount: number
  item: number
  contact: {
    address1: string
    address2: string
    city: string
    state: string
    country: string
    zipcode: string
    phone: string
  }
}) => {
  const response = await api.post('/create/order', params)
  return response.data
}
